import { useGetEventsQuery } from "./eventsApiSlice"
import Event from "./Event" // ध्यान दें: Event को अब `memoizedEvent` के रूप में एक्सपोर्ट किया गया है
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import { Spinner } from "react-bootstrap"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"


const EventList = () => {
    useTitle('Nirakar Satgur: Events List')

    const { id, isManager, isAdmin } = useAuth()
    const { pageNumber = 1 } = useSelector((state) => state?.event || {}); 
    
    const {
        data: events,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetEventsQuery({ page: pageNumber }, {
        refetchOnFocus: false,
        refetchOnMountOrArgChange: true
    });

    console.log(error,isError,isSuccess,events)
    

    let content

    if (isLoading) content = <Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner>

    if (isError) {
        content = <p className="errmsg">{error?.data?.message || "इवेंट्स लोड करने में त्रुटि।"}</p>
    }

    if (isSuccess) {
        const { ids, entities } = events

        let filteredIds
        if (isManager || isAdmin) {
            filteredIds = [...ids] // सभी इवेंट्स दिखाते हैं
        } else {
            filteredIds = ids.filter(eventId => entities[eventId].createdBy === id) // केवल यूजर द्वारा बनाए गए इवेंट्स दिखाते हैं
        }

        const tableContent = ids?.length && filteredIds.map((eventId, index) => <Event key={eventId} eventId={eventId} index={index} />)
        console.log("Total event IDs from API:", ids);
console.log("Filtered event IDs for current user/role:", filteredIds);
console.log("Entities:", entities);

        content = (
            <>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="pageHeading">इवेंट सूची</h2>
                    <Link className="btn btn-primary" to='/dashboard/events/new'>नया इवेंट जोड़ें</Link>
                </div>
                
                <table className="table table--events">
                    <thead className="table__thead">
                        <tr>
                            <th scope="col" className="table__th">क्रम सं.</th>
                            <th scope="col" className="table__th">नाम</th>
                            <th scope="col" className="table__th">आयोजक</th>
                            <th scope="col" className="table__th">तारीख</th>
                            <th scope="col" className="table__th">समय</th>
                            <th scope="col" className="table__th">स्थान</th>
                            <th scope="col" className="table__th">प्रकार</th>
                            <th scope="col" className="table__th">ज़ूम लिंक</th>
                            <th scope="col" className="table__th">मानचित्र लिंक</th>
                            <th scope="col" className="table__th">बैनर</th>
                            <th scope="col" className="table__th">कार्यवाई</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableContent}
                    </tbody>
                </table>
                {!isLoading && !isError && filteredIds.length === 0 && (
                    <p className="text-center mt-4">कोई इवेंट नहीं मिला।</p>
                )}
            </>
        )
    }

    return content
}
export default EventList